export default __webpack_public_path__ + "static/media/pgmico(31).07632c27.png";